import type { BatteryProposalDto } from "~/api/dto/battery-proposal.dto"

import { isBatteryProposalReadOnly } from "../battery-proposal-read-only"

export const RESERVE_NOW_LABEL = `Reserve now`
export const CONTRACT_STATUS_LABEL = `Contract status`

export type ResolvedContractAction = { reserve: boolean; label: string }

/**
 * Server-derived Contract entry for the proposal page. Null hides every entry;
 * otherwise the server's `contractAction` decides between Reserve now and
 * Contract status.
 */
export const resolveContractAction = (
  proposal: BatteryProposalDto,
): ResolvedContractAction | null => {
  if (isBatteryProposalReadOnly(proposal) || !proposal.contractAction) {
    return null
  }
  const reserve = proposal.contractAction === `reserve_now`
  return {
    reserve,
    label: reserve ? RESERVE_NOW_LABEL : CONTRACT_STATUS_LABEL,
  }
}
